import script from "./HomeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeForm.vue?vue&type=script&setup=true&lang=js"

import "./HomeForm.vue?vue&type=style&index=0&id=31e9cb9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e9cb9c"]])

export default __exports__